export default __webpack_public_path__ + "static/media/icon_upload.d46b63fe.svg";